import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './app/App';
import { store } from './app/store';
import * as serviceWorker from './serviceWorker';
import 'festo-react-ui-kit/lib/main_css.css';
import '@festo-ui/web-essentials/dist/css/festo-web-essentials.min.css';
import './index.scss';
import { SnackbarProvider } from '@festo-ui/react';
import { OidcProvider } from 'redux-oidc';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
		<OidcProvider userManager={store.getState().authConfiguration.userManager} store={store}>
			<SnackbarProvider>
				<App/>
			</SnackbarProvider>
		</OidcProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
